module.exports = __webpack_public_path__ + "img/ic_publicity_detail4_2.7fe9090b.jpeg";